import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseConsultation } from "./UseConsultation";
import CustomPagination from "../../components/CustomPagination";
import useBreakpoints from "../../hooks/useBreakpoints";
import AssignmentIcon from "@mui/icons-material/Assignment";

export default function ConsultationHistory(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetHistoryById } = UseConsultation();
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState([]);
  const [hasMore, setHasMore] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [openDescription, setOpenDescription] = useState({
    show: false,
    description: "",
  });
  useEffect(() => {
    if (props.consultantID) {
      setProgress(true);
      GetHistoryById(props.consultantID, pageState.page, (details) => {
        if (details.length) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
        let fullList = [...state, ...details];

        details = fullList;
        setState(details);
      });
    }
  }, [pageState, props.consultantID]);

  function newFunc(pags) {
    setPageState((old) => ({ page: pageState.page + 1 }));
  }

  const columns = [
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      hide: true,
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "consulator",
      headerName: "مشاور",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.consulator}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 140,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.stateTitle}
          </Typography>
        );
      },
    },
    {
      field: "جزییات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "جزییات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="add Client">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setOpenDescription({
                  show: true,
                  description: cellValues.row.description,
                });
              }}
            >
              <AssignmentIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => {
        props.setShowHistory(false);
      }}
      open={props.showHistory}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Typography sx={{ width: 1, textAlign: "left" }}>
          تاریخچه کاربر
        </Typography>
        <Box sx={{ width: 1, height: "20rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={state ? state : []}
            page={pageState.page - 1}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={state && state.length ? state.length : 1}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                showMoreConsultant: true,
                hasMore: hasMore,
                nofab: true,
                noPage: true,
                isLtr: true,
                newFunc: newFunc,
                rowCount: state && state.length ? state.length : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "rowNO",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        </Box>
        <Button
          variant="outlined"
          onClick={() => {
            props.setShowHistory(false);
          }}
        >
          بستن
        </Button>
      </DialogContent>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenDescription({ show: false, description: "" });
        }}
        open={openDescription.show}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
            alignItems: "center",
          }}
        >
          <TextField
            label="توضیحات"
            multiline
            rows={6}
            fullWidth
            value={
              openDescription.description ? openDescription.description : ""
            }
            size="small"
            variant="filled"
          />
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              setOpenDescription({ show: false, description: "" });
            }}
          >
            بستن
          </Button>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
}
